


































import Vue from 'vue';
export default Vue.extend({
  props: ['title', 'body', 'onConfirm', 'open'],
  data() {
    return {
      dialog: this.open,
      loading: false,
    };
  },
  watch: {
    open(val) {
      this.dialog = val;
    },
  },
  methods: {
    async yes() {
      this.loading = true;
      await this.onConfirm(true);
      this.loading = false;
    },
    no() {
      this.onConfirm(false);
    },
  },
});
